// The "4× oftare" claim shown in the boost modals — the same figure as the
// existing boost copy ("4X fler besökare"), not measured: the summary API
// has no un-boosted baseline.
export const BOOST_EXPOSURE_MULTIPLIER = 4;

// A personal re-boost offer applies this long after the boost ended, and
// for as long the Boost button reopens the result panel instead of the
// purchase modal.
export const REBOOST_OFFER_WINDOW_HOURS = 24;
